export default {
  title: 'Potwierdzenie hasła*',
  type: 'object',
  properties: {
    currentPassword: {
      type: 'string',
      title: 'schema.password.currentPassword',
      disabled: '!this.showCurrentPassword',
      minLength: 8,
      validationMessages: {
        required: 'Obecne hasło jest wymagane'
      }
    },
    password: {
      type: 'string',
      title: 'schema.password.password',
      fieldRequired: true,
      minLength: 8,
      validFunc: 'new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])").test($value)',
      validationMessages: {
        required: 'Hasło jest wymagane',
        minLength: 'Minimalna długość hasła wynosi 8',
        validFunc: 'Hasło powinno zawierać przynajmniej jedną dużą literę, jedną małą literę, cyfrę oraz znak specjalny'
      }
    },
    repeat: {
      computed: true,
      type: 'string',
      title: 'schema.password.repeat',
      fieldRequired: true,
      validFunc: '$value && this.password ? $value === this.password : true',
      validationMessages: {
        required: 'Powtórzenie hasła jest wymagane',
        validFunc: 'Oba hasła muszą być takie same'
      }
    },
    showCurrentPassword: {
      type: 'boolean',
      computed: true,
      default: false
    }
  }
};
